<script lang="ts" module>
    export const route = "/oauth-popup";
    export const sessionRequired = false;
</script>

<script lang="ts">
    import { BooleanAsStringSchema, z, definedOrDie } from "@repo/utils";
    import { auth } from "../lib/auth.svelte.js";
    import { useURL } from "../lib/url.svelte.js";
    import { resolve } from "../lib/route.svelte.js";

    const url = useURL({
        sso: BooleanAsStringSchema,
        provider: z.string(),
        loginHint: z.string(),
        requestSignUp: BooleanAsStringSchema,
    });
    if (url.query.sso) {
        auth.signIn.sso({
            providerId: definedOrDie(url.query.provider),
            loginHint: url.query.loginHint,
            requestSignUp: url.query.requestSignUp,
            callbackURL: resolve("/closing-page"),
            errorCallbackURL: resolve("/error"),
        });
    } else {
        auth.signIn.social({
            provider: definedOrDie(url.query.provider),
            loginHint: url.query.loginHint,
            requestSignUp: url.query.requestSignUp,
            callbackURL: resolve("/closing-page"),
        });
    }
</script>
